<template>
  <div class="container">
    <!-- 首屏Banner区 -->
    <Carousel v-model="value3">
      <Carousel-item v-for="item in bannerList" :key="item">
        <div class="carousel-item">
          <img :src="item.imagePath | qiniuResource" />
        </div>
      </Carousel-item>
    </Carousel>

    <!-- 关于我们区 -->
    <section class="about-section">
      <div class="section-container">
        <div class="section-title-wrapper">
          <div class="section-title-bg">ABOUT UNIS</div>
          <h2 class="section-title">ABOUT UNIS</h2>
          <p class="section-subtitle">关于我们</p>
        </div>
      </div>
      <div class="section-container b1-box">
        <div class="about-content" data-flex="cross:top">
          <div class="about-image" @click="modal1 = true">
            <img class="mainVideo" :src="articleInfo.mainVideo | videoImgUrl()" />
            <img class="play" src="/static/img/xx-03.png" />
            <!-- <video controls  :src="articleInfo.mainVideo | qiniuResource"></video> -->
          </div>
          <div class="about-text">
            <div class="about-text1">{{ articleInfo.introduce }}</div>
          </div>
        </div>
        <div class="b1"></div>
      </div>
    </section>

    <!-- 企业数据统计区 -->
    <section class="about-section">
      <div class="section-container b2-box">
        <div class="tj-box">
          <img :src="aboutUnis.mainImage | qiniuResource" />
        </div>
      </div>
    </section>

    <!-- 产品类别 -->
    <section class="about-section">
      <div class="section-container">
        <div class="section-title-wrapper">
          <div class="section-title-bg">PRODUCT CATEGORY</div>
          <h2 class="section-title">PRODUCT CATEGORY</h2>
          <p class="section-subtitle">产品类别</p>
        </div>
        <Carousel v-model="value1" dots="none" arrow="none">
          <Carousel-item v-for="item in productList" :key="item">
            <div class="products-grid">
              <div class="product-card" v-for="it in item">
                <div class="product-image">
                  <img :src="it.mainImage | qiniuResource" />
                </div>
                <!-- <div class="product-label">{{ it.title }}</div> -->
              </div>
            </div>
          </Carousel-item>
        </Carousel>
        <div class="step-box" v-if="productList.length > 1">
          <img class="reduce" @click="onReduce" src="/static/img/xx-04.png" alt="">
          <img class="plus" @click="onPlus" src="/static/img/xx-05.png" alt="">
        </div>
      </div>
    </section>

    <!-- 关于我们区 -->
    <section class="about-section">
      <div class="section-container">
        <div class="section-title-wrapper">
          <div class="section-title-bg">COOPERATION PARTNER</div>
          <h2 class="section-title">COOPERATION PARTNER</h2>
          <p class="section-subtitle">合作伙伴</p>
        </div>

        <Carousel v-model="value2">
          <Carousel-item v-for="item in partnerList" :key="item">
            <div class="carousel-item">
              <img class="banner" :src="item.mainImage | qiniuResource" />
            </div>
          </Carousel-item>
        </Carousel>
      </div>
    </section>

    <Modal v-model="modal1" title="关于我们" width="800">
      <video controls width="100%" height="400" :src="articleInfo.mainVideo | qiniuResource"></video>
    </Modal>
  </div>
</template>

<script>
import { isObject, isArray, isString, isEmpty, str2timestamp, get } from '../libs/common_funcs'
import CommonMixin from '../mixins/common'

export default {
  mixins: [CommonMixin],
  name: 'Index',
  created() {
    this.loadData()
  },
  watch: {
  },
  mounted() {
  },
  data() {
    return {
      isLoading: true,
      value1: 0,
      value2: 0,
      value3: 0,
      bannerList: [],
      partnerList: [],
      aboutUnis: {},
      productList: [],
      articleInfo: {},
      modal1: false
    };
  },
  methods: {
    async loadData() {
      Promise.all([
        // 轮播图
        this.apiGet('get.advertising', {
          type: 1
        }),
        // 合作伙伴
        this.apiGet('get.partner'),
        // 内容
        this.apiGet('get.picture', {
          type: 1
        }),
        // 产品
        this.apiGet('get.product'),
        // 文章资讯-关于我们
        this.apiGet('get.article', {
          type: 1
        }),
      ]).then(results => {
        this.bannerList = results[0].list
        this.partnerList = results[1].list
        this.aboutUnis = results[2].obj
        this.productList = this.splitArray(results[3].list, 3);
        this.articleInfo = results[4].obj
        this.isLoading = false
      })
        .catch(err => (this.isLoading = false))
    },
    splitArray(arr, groupSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += groupSize) {
        result.push(arr.slice(i, i + groupSize));
      }
      return result;
    },
    onReduce() {
      let value1 = this.value1
      if (value1 == 0) return
      this.value1--
    },
    onPlus() {
      let value1 = this.value1
      let value2 = this.productList.length
      console.log('value1', value1)
      console.log('value2', value2)
      if (value1 == (value2 - 1)) return
      this.value1++
    }
  },
  computed: {

  },
  components: {
  },
  destroyed() {
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #ffffff;
  padding-bottom: 30px;
  padding-top: 70px;

  .carousel-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 保持比例并覆盖容器 */
    object-position: center;
  }
}

/* ========== Section Common Styles ========== */
.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px;
}

.section-title-wrapper {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
}

.section-title-bg {
  font-size: 80px;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.05);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  z-index: 0;
}

.section-title {
  font-size: 34px;
  font-weight: 700;
  color: #e63946;
  position: relative;
  z-index: 1;
  margin-bottom: 0.5rem;
}

.section-subtitle {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  position: relative;
  z-index: 1;
}

.b1-box {
  position: relative;

  .about-content {
    z-index: 9;
    position: relative;
  }

  .b1 {
    background: url('/static/img/xx-06.png') no-repeat;
    background-size: cover;
    width: 1324px;
    height: 600px;
    text-align: center;
    margin: 0 auto;
    position: absolute;
    top: -33px;
    left: -101px;
  }
}

.b2-box {
  margin-top: 100px;
}

/* ========== About Section ========== */
.about-section {
  background: #ffffff;
}

.about-content {
  width: 100%;
}

.about-image {
  position: relative;
  cursor: pointer;

  .mainVideo {
    width: 686px;
    height: 384px;
  }

  .play {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50px;
    height: 50px;
    margin-left: -25px;
    margin-top: -25px;
  }
}


.about-text {
  padding: 0;
  margin-top: 10px;
  width: 100%;
}

.about-text1 {
  font-size: 16px;
  line-height: 40px;
  padding-left: 20px;
}

.more-button {
  margin-top: 20px;
  background: #e63946;
  color: #fff;
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 300ms;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.more-button:hover {
  background: #E50012;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(230, 57, 70, 0.3);
}

.tj-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 保持比例并覆盖容器 */
  object-position: center;
}

/* ========== Stats Section ========== */
.stats-section {
  background: #fff;
  padding: 30px 0;
}

.stats-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.stat-item {
  text-align: center;
  padding: 30px;
}

.stat-number {
  font-size: 60px;
  font-weight: 800;
  color: #E50012;
  line-height: 1;
  margin-bottom: 30px;
}

.stat-unit {
  font-size: 16px;
  color: #E50012;
  font-weight: 400;
  vertical-align: top;
  margin-left: 10px;
}

.stat-label {
  font-size: 16px;
  color: #E50012;
  margin-top: 30px;
  font-weight: bold;
}

// 
.products-grid {
  padding: 30px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  flex: 1;
}

.product-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 300ms;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
}

.product-image {
  // width: 410px;
  // height: 548px;
  background: linear-gradient(135deg, #f5f5f5, #e0e0e0);
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image img {
  width: 100%;
  height: 100%;
}

.product-label {
  padding: 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  background: white;
}

.step-box {
  position: relative;
  width: 100%;

  img {
    width: 60px;
    height: 60px;
  }

  .reduce {
    position: absolute;
    left: -90px;
    top: -340px;
    cursor: pointer;
  }

  .plus {
    position: absolute;
    right: -90px;
    top: -340px;
    cursor: pointer;
  }
}

@media (max-width: 768px) {
  .container {
    padding-top: 50px;
  }

  .section-container {
    padding: 20px;
  }

  .section-title-wrapper {
    margin-bottom: 20px;
  }

  .section-title-bg {
    font-size: 40px;
  }

  .section-title {
    font-size: 16px;
  }

  .about-content {
    display: block;
  }

  .about-image {
    .mainVideo {
      width: 100%;
      height: 400px;
    }
  }

  .about-text1 {
    font-size: 14px;
    line-height: 30px;
    padding: 0;
  }
  .about-text {
    margin-top: 10px;
    padding-left: 0px;
  }

  .b1-box {
    position: relative;

    .b1 {
      background: none;
      width: 1324px;
      height: 600px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue